import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import ChainedBackend from 'i18next-chained-backend'
import I18NextLocalStorageBackend from 'i18next-localstorage-backend'
import localStorageKeys from './utils/localStorageKeys'
import {envConfig} from './utils/env'

const lang = localStorage.getItem(localStorageKeys.LANGUAGE) || envConfig.locale || 'en'
const LOCALE_VERSION = 'v11'

const CRITICAL_NS = ['resources', 'main-layout', 'sidebar', 'footer', 'loader', 'resourcesData', 'titles', 'modals']

const ALL_NS = [
    'resources', 'resourcesData', 'footer', 'apply-voucher', 'billings',
    'confirm-code', 'customer-settings', 'security',
    'incidents', 'integrations', 'job', 'job-events', 'jobs',
    'log-groups', 'log-management', 'members', 'monitoring', 'not-found',
    'notifications', 'on-call-scheduling', 'payment-methods', 'plans',
    'redeem-coupon', 'rulesets', 'server-monitoring', 'services', 'statuspages',
    'subscription', 'teams', 'usage', 'confirm', 'feedback', 'for-paid', 'slider',
    'tutorial', 'loader', 'main-layout', 'sidebar', 'date-interval',
    'integrations-team-menu', 'job-table', 'job-chart', 'instructions',
    'resource-incidents', 'resource-integrations', 'titles', 'modals',
    'condition-types', 'interval-units', 'server-metrics', 'usage-limits',
    'zapier-types', 'validation', 'phone-calls', 'forms'
]

const initPromise = i18n
    .use(ChainedBackend)
    .use(initReactI18next)
    .init({
        lng: lang,
        fallbackLng: 'en',
        debug: false,
        react: {bindI18n: 'languageChanged loaded', useSuspense: false},
        ns: CRITICAL_NS,
        defaultNS: 'resources',
        keySeparator: false,
        backend: {
            backends: [
                I18NextLocalStorageBackend,
                resourcesToBackend((lng, ns) =>
                    import(`../public/locales/${lng}/${ns}.json`)
                )
            ],
            backendOptions: [
                {
                    versions: {en: LOCALE_VERSION, az: LOCALE_VERSION},
                    expirationTime: 24 * 60 * 60 * 1000
                }
            ]
        },
        interpolation: {escapeValue: false}
    })

initPromise.then(() => {
    i18n.loadNamespaces(ALL_NS)
})

export {initPromise}
export default i18n